import { t as cn } from "../cn-DC5bfWZT.js";
import { jsx } from "react/jsx-runtime";
function Icon({ name: n, size: r, label: i, spriteHref: a, className: o, width: s, height: c,...l }) {
	return /* @__PURE__ */ jsx("svg", {
		width: r ?? (typeof s == "number" ? s : void 0) ?? 16,
		height: r ?? (typeof c == "number" ? c : void 0) ?? 16,
		role: i ? "img" : void 0,
		"aria-label": i,
		"aria-hidden": i ? void 0 : !0,
		focusable: "false",
		className: cn("inline-block", o),
		"data-slot": "icon",
		...l,
		children: /* @__PURE__ */ jsx("use", { href: `${a}#${n}` })
	});
}
export { Icon };
